import { z } from "zod/mini"

const widgetKeyRegex = /^[^<>]+$/

export const WidgetKeySchema = z.string().check(
	z.refine((s) => s.length === 0 || widgetKeyRegex.test(s), {
		error: () => "The value must not contain < or > characters",
	}),
)

export type WidgetKey = z.infer<typeof WidgetKeySchema>
